<template>
  <div>
    <van-swipe-cell v-for="(item, index) in data" :key="index">
      <van-card
        :desc="'Marka:' +$helper.ilkharfBuyuk(item.marka).substring(0, 80)"
        :title="$helper.ilkharfBuyuk(item.isim).substring(0, 80)"
        :price="$helper.parabirimi(item.fiyat.maliyet, 'TL')"
        origin-price="10.00"
        :centered="true"
        currency=""
        class="goods-card"
        thumb="https://delta.egem.site/upload/6351_08072022151410.png"
        @click="detay(item,index)"
      >
        <template #footer >
            
            <van-badge :content="20" max="9" style="margin-top:-80px">
                <div class="child">
                <van-icon size="40" color="#ccc" name="apps-o"/>
            </div>
        </van-badge>
            <van-badge :content="20" max="9" style="margin-top:-40px"><div class="child" /></van-badge>



            <!-- <van-button round size="mini" :color="durum[item.durum].color">{{ item.miktar }}</van-button>
            <van-button round size="mini" color="#FE5E3A">{{ item.sepetadet }}</van-button> -->
        </template>
      </van-card>
      <template #right>
        <van-button text="Detay" type="primary" class="delete-button" @click="detay(item)"/>
      </template>
    </van-swipe-cell>

  </div>

</template>
<script>

export default {
  props: {
    data: {
      type: Array,
      require:true
    },
    durum: {
      type: Object,
      require:true
    },
  },
  data() {
    return {
      mesaj : '',
      activeNames :0,
      item:this.$store.getters.getStok.aktif,
      cari:this.$store.getters.getCari.aktif,
      adet:0
    };
  },

  methods: {

    addBasket(obje) {
      this.$emit("addBasket",obje)
    },
    deleteBasket(obje){
      this.$emit("delBasket",obje)
    },
    detay(obje) {
        this.$emit("detay",obje)
    },
    close(){
      this.$emit("closePop")
    }

  }
};
</script>
<style scoped>
  .child {
    width: 30px;
    height: 30px;
    background: #f2f3f5;
    border-radius: 4px;
  }
</style>


// WEBPACK FOOTER //
// src/components/card.vue